var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"search-result-length",class:_vm.className},[_vm._v("\n  "+_vm._s(isNaN(_vm.resultLength) ? '...' : _vm.resultLength)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }